export class Department {
  id = -1;
  name = "";
  timezone = "";
  size = 0;
  default_accounting_category_id: number | null = null;
  labor_hourly_cost_cents: 0;
  late_fees_enabled: false;
  late_fee_per_minute_cents: 0;
  max_late_fee_cents: 0;
  late_fee_accounting_category_id: number | null = null;
  archived = false;
  resource_url = "";
  integrations: {
    pulse_m: DepartmentIntegration;
  };
  links: {
    archive_confirm?: string; // GET
    archive?: string; // PUT
    unarchive?: string; // PUT
  };

  constructor(params: Partial<Department> = {}) {
    Object.assign(this, params);
  }
}

export class DepartmentIntegration {
  enabled = false;
  location_id: number | null = null;

  constructor(params: Partial<DepartmentIntegration> = {}) {
    Object.assign(this, params);
  }
}

export class DepartmentArchiveConfirm {
  effected_objects = {
    technicians: 0,
    jobs: 0,
    service_categories: 0
  };

  get hasNothingToArchive() {
    const count = Object.values(this.effected_objects).reduce(
      (acc, count) => acc + count
    );
    return count === 0;
  }

  constructor(params: Partial<DepartmentArchiveConfirm> = {}) {
    Object.assign(this, params);
  }
}
